import { render, staticRenderFns } from "./releaseGoods.vue?vue&type=template&id=27296660&scoped=true&"
import script from "./releaseGoods.vue?vue&type=script&lang=js&"
export * from "./releaseGoods.vue?vue&type=script&lang=js&"
import style0 from "./releaseGoods.vue?vue&type=style&index=0&id=27296660&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27296660",
  null
  
)

export default component.exports